import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material';
import store from '../../store';
import messages from '../../i18n';
import AbandonedCartToasts from '../../blocks/AbandonedCartToasts';
import { purpleTheme } from '../../themes/default';

const locale = 'en-US';

const queryClient = new QueryClient();

if (window.location.href.includes('/cart')) {
  const abandonedCartBannerContainer = document.getElementById(
    'abandoned-cart-banner',
  );
  if (abandonedCartBannerContainer) {
    const abandonedCartBannerRoot = createRoot(abandonedCartBannerContainer);
    abandonedCartBannerRoot.render(
      <QueryClientProvider client={queryClient}>
        <IntlProvider
          messages={messages[locale]}
          locale={locale}
          defaultLocale="en"
        >
          <ThemeProvider theme={purpleTheme()}>
            <Provider store={store}>
              <AbandonedCartToasts />
            </Provider>
          </ThemeProvider>
        </IntlProvider>
      </QueryClientProvider>,
    );
  }
} else {
  const abandonedCartToastContainer = document.getElementById(
    'abandoned-cart-toast',
  );

  if (abandonedCartToastContainer) {
    const abandonedCartToastRoot = createRoot(abandonedCartToastContainer);
    abandonedCartToastRoot.render(
      <QueryClientProvider client={queryClient}>
        <IntlProvider
          messages={messages[locale]}
          locale={locale}
          defaultLocale="en"
        >
          <ThemeProvider theme={purpleTheme()}>
            <Provider store={store}>
              <AbandonedCartToasts />
            </Provider>
          </ThemeProvider>
        </IntlProvider>
      </QueryClientProvider>,
    );
  }
}
